class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');

    if (this.mainDetailsToggle.classList.contains('mega-menu')) {
      this.hoverMediaQuery = window.matchMedia('(min-width: 990px)');
      this.closeTimeout = null;

      this.addEventListener('mouseenter', this.onMegaMenuMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMegaMenuMouseLeave.bind(this));
      this.summary.addEventListener('click', this.onMegaMenuSummaryClick.bind(this));
    }
  }

  onMegaMenuMouseEnter() {
    if (!this.hoverMediaQuery.matches) return;
    clearTimeout(this.closeTimeout);
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  onMegaMenuMouseLeave() {
    if (!this.hoverMediaQuery.matches) return;
    this.closeTimeout = setTimeout(() => this.close(), 150);
  }

  onMegaMenuSummaryClick(event) {
    if (!this.hoverMediaQuery.matches) return;
    event.preventDefault();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
